var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngryicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_546",
    "data-name": "Grupo 546",
    transform: "translate(0.454 0.362)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1511",
    "data-name": "Ret\\xE2ngulo 1511",
    width: 69,
    height: 70,
    rx: 10,
    transform: "translate(-0.454 -0.362)",
    fill: "#fd6643"
  }), /*#__PURE__*/React.createElement("g", {
    id: "angry",
    transform: "translate(14.816 14.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_474",
    "data-name": "Grupo 474",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_469",
    "data-name": "Grupo 469",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_468",
    "data-name": "Grupo 468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2692_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2693_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2694_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2695_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2696_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2697_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2698_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2699_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2723_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2739_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2740_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2741_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2742_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2743_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2744_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_161",
    "data-name": "Elipse 161",
    cx: 19.537,
    cy: 19.537,
    rx: 19.537,
    ry: 19.537,
    fill: "#fff"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_471",
    "data-name": "Grupo 471",
    transform: "translate(11.447 21.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_614",
    "data-name": "Caminho 614",
    d: "M197.678,286.09h-3.8a4.289,4.289,0,1,0-8.579,0h-3.8a8.09,8.09,0,0,1,16.18,0Z",
    transform: "translate(-181.498 -278)",
    fill: "#fd6643"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_472",
    "data-name": "Grupo 472",
    transform: "translate(7.716 10.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_615",
    "data-name": "Caminho 615",
    d: "M155.647,175.355a4.331,4.331,0,1,1-7.2-4.227Z",
    transform: "translate(-147.131 -171.128)",
    fill: "#fd6643"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_616",
    "data-name": "Caminho 616",
    d: "M294.956,174.239a4.331,4.331,0,0,1-8.516,1.116l7.2-4.227A4.319,4.319,0,0,1,294.956,174.239Z",
    transform: "translate(-271.313 -171.128)",
    fill: "#fd6643"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngryicon);
export default __webpack_public_path__ + "static/media/angryicon.958fbacc94a9f92c7748882d36221e85.svg";
export { ForwardRef as ReactComponent };